import { GroupItemBaseTriggerItemsQualifier } from "./group-item-base-trigger-items";
export class FirstMatchGroupItemTriggerItemsQualifier extends GroupItemBaseTriggerItemsQualifier {
    _qualifyCouponItemsGroupQTY(group, coupon, cart, couponGroupItems) {
        const triggerItems = [];
        for (const cItem of couponGroupItems) {
            const found = [];
            while (found.length < cItem.quantity) {
                const tItem = this._qualifyCouponItemsGroup(group, coupon, cart, cItem);
                if (!tItem)
                    break;
                found.push(tItem);
            }
            if (found.length === cItem.quantity) {
                triggerItems.push(...found);
            }
            if (triggerItems.length > 0)
                break; // stop after first qualified
        }
        return triggerItems;
    }
}
//# sourceMappingURL=first-match-group-item-trigger-items.js.map